import { Box, Button, SvgIcon } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import HoldUpIcon from '@assets/icons/holdUpIcon.svg?component';
import CloseIcon from '@mui/icons-material/Close';

interface InternetRequiredModalProps {
  open: boolean;
  onClose: () => void;
  categoryLabel: string;
}

export const InternetRequiredModal = ({ open, onClose, categoryLabel }: InternetRequiredModalProps) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth variant="warning">
      <IconButton
        onClick={onClose}
        aria-label="close"
        size="small"
        sx={{ position: 'absolute', top: 12, right: 12, color: theme.novus.borderBlack }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: '24px 72px' }}>
        <Stack alignItems="center" sx={{ py: 2 }}>
          <Box sx={{ mt: '40px' }}>
            <SvgIcon component={HoldUpIcon} sx={{ fontSize: '163px' }} />
          </Box>

          <Typography
            variant="title.dialog"
            textAlign="center"
            mt="24px"
            color={theme.novus.primaryBrandBlue}
          >
            Hold Up!
          </Typography>

          <Typography variant="body.md" textAlign="center" mt="20px">
            {`${categoryLabel} can't go solo, they need an Internet plan buddy first. Pick your Internet plan first to add a ${categoryLabel} plan.`}
          </Typography>

          <Stack direction="row" gap="15px" mt="27px">
            <Button variant="contained" onClick={onClose}>
              Close
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
